
import { loadStyle } from '../utils/css'
import uuid from  '@aeppic/shared/uuid'
import Vue from '../../externals/vue.js'

const STYLE = `
  .ae-tabs--empty {
    flex:1;
    min-width: 45px;
    border-bottom: 1px solid var(--ae-ui-element-border-color, #aaa);
  }

  .ae-tabs--container{
    display:flex;
    flex-direction: column;
  }

  .ae-tabs--header {
    position: relative;
    z-index: 0;
    white-space: nowrap;
    overflow-y: none;
    overflow-x: auto;
    width:100%;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
  }

  .ae-tabs {
    opacity: 1;
    display: flex;
    flex-direction: column;
    /* flex-wrap: wrap; */
    width: 100%;
  }

  .ae-tabs--label {
    display: inline-block;
    cursor: pointer;
    padding: 5px 15px;
    background: transparent;
    border-top: 1.6px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    margin-right: -1px;
    /* margin-left: -1px; */
    border-bottom: 1px solid var(--ae-ui-element-border-color, #aaa);
    transition: all 0.05s ease-in-out;
    text-align: center;
    font-weight: bold;
    color: var(--ae-foreground-l3, #aaa);
  }

  .ae-tabs--label.ae-tabs--label--wide {
    padding: 5px 24px;
  }

  .ae-tabs--label-prefix {
    color: var(--ae-primary);
    pointer-events: none;
  }

  .ae-tabs--label--with-sublabel {
    padding: 4px 24px 3px 24px;
    pointer-events: none;
  }

  .ae-tabs--label:focus {
    outline:none;
  }

  .ae-tabs--label--pinned {
    /*color: var(--ae-primary);*/
  }

  .ae-tabs--label--active {
    border-top-color: var(--ae-primary, #aaa);
    border-left-color: var(--ae-ui-element-border-color, #aaa);
    border-right-color: var(--ae-ui-element-border-color, #aaa);
    border-bottom-color: var(--ae-background-d1, #fafafa);
    color: var(--ae-foreground-l2);
    background: var(--ae-background-d2, #fafafa);
    position:relative;
    z-index: 1;
  }


  .ae-tabs--label--active::after {
    content:'';
    position: absolute;
    bottom:0;
    left:0;
    right:0;
  }

  .ae-tabs--label:hover {
    background: var(--ae-background-d2, rgba(238,238,238,0.8));
  }

  .ae-tabs--content {
    flex: 1;
    overflow: auto;
    position: relative;  
    width: 100%;
    padding-top: 8px;   
  }

  .ae-tabs--label--show-on-hover {
    opacity: 0;
  }

  .ae-tabs--label-text {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    pointer-events: none;
  }

  .ae-tabs--label:hover .ae-tabs--label--show-on-hover {
    opacity: 1;
  }

  .ae-tabs--label--action-icon {  
    width: 10px;
    height: 10px;
    display: block;
  }
`

export default {
  /* tslint:disable */
  render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ae-tabs ae-tabs--container"},[_c('div',{staticClass:"ae-tabs--header"},[_vm._l((_vm.tabs),function(tab,tabIndex){return _c('div',{ref:"tabHeaders",refInFor:true,staticClass:"ae-tabs--label ae-noselect",class:{ 'ae-tabs--label--active': _vm.showTabIndex===tabIndex, 'ae-tabs--label--wide': tab.allowPin || tab.allowClose, 'ae-tabs--label--with-sublabel': tab.sublabel, 'ae-tabs--label--pinned': tab.pinned},staticStyle:{"position":"relative"},attrs:{"id":'header-' + tab.id},on:{"click":function($event){return _vm.showTab(tab)}}},[_c('div',{staticStyle:{"position":"absolute","top":"1px","left":"2px","z-index":"1"}},[_c('div',{on:{"click":function($event){tab.allowPin && _vm.togglePin(tab)}}},[(tab.allowPin && !tab.pinned)?_c('ae-icon',{key:"fal fa-thumbtack",staticClass:"fal fa-thumbtack ae-tabs--label--action-icon ae-tabs--label--show-on-hover"}):_vm._e(),_vm._v(" "),(tab.pinned)?_c('ae-icon',{key:"fas fa-thumbtack",staticClass:"fas fa-thumbtack ae-tabs--label--action-icon",staticStyle:{"margin-top":"3px"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","top":"2px","right":"2px","z-index":"1"}},[_c('div',{on:{"click":function($event){$event.stopPropagation();tab.allowClose && _vm.closeTab(tab)}}},[(tab.allowClose)?_c('ae-icon',{staticClass:"fas fa-times ae-tabs--label--action-icon ae-tabs--label--show-on-hover"}):_vm._e()],1)]),_vm._v(" "),(tab.label)?_c('div',{staticClass:"ae-tabs--label-text"},[_c('span',{staticClass:"ae-tabs--label-prefix"},[_vm._v(_vm._s(tab.labelPrefix))]),_vm._v(" "),_c('label',{attrs:{"for":tab.id,"aria-hidden":"true","tabindex":"-1","title":tab.label}},[_vm._v(_vm._s(tab.label))])]):_vm._e(),_vm._v(" "),(tab.sublabel)?_c('div',{staticClass:"ae-tabs--label-text"},[_c('small',{attrs:{"title":tab.sublabel}},[_vm._v(_vm._s(tab.sublabel))])]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"ae-tabs--empty",staticStyle:{"position":"relative"}})],2),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","flex-direction":"column"}},_vm._l((_vm.tabs),function(tab,tabIndex){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTabIndex===tabIndex),expression:"showTabIndex===tabIndex"}],staticClass:"ae-tabs--content",class:{ 'ae-expand-region': _vm.limitExpand },attrs:{"id":tab.id,"data-ae-edit-context-boundary":"true"}},[(tab.layoutId)?_c('ae-layout',_vm._g({attrs:{"layout-id":tab.layoutId,"params":tab.params}},tab.events)):(tab.design)?_c('ae-design',_vm._g({attrs:{"name":tab.design,"document":tab.document,"params":tab.params}},tab.events)):_vm._e()],1)}),0)])},
  staticRenderFns: [],
  /* tslint:enable */
  
  props: {
    limitExpand: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      tabs: [],
      showTabIndex: -1
    }
  },
  mounted() {
    loadStyle(STYLE)
  },
  methods: {
    addTab(newTab) {
      const emptyTab = {
        label: '',
        pinned: false,
        allowPin: false,
        allowClose: false,
        dynamic: false,
        params: {},
        events: {},
      }

      const tabToAdd = newTab || emptyTab
      tabToAdd.id = uuid()
      this.tabs.push(tabToAdd)

      Vue.nextTick(() => this.showTab(tabToAdd))
      return tabToAdd
    },

    showTab(tab) {
      for (let i = 0; i < this.tabs.length; i++) {
        if (tab.id === this.tabs[i].id) {
          this.showTabIndex = i
          this.scrollTabHeaderIntoView(tab)
          return tab
        }
      }

      this.addTab(tab)
      return tab
    },

    closeTab(tab) {
      for (let i = 0; i < this.tabs.length; i++) {
        if (tab.id === this.tabs[i].id) {
          this.tabs.splice(i, 1)
          tab.pinned = false   
          if (tab.events && tab.events['tab-closed']) {
            tab.events['tab-closed'](tab)
          }
          this.emitTabEvent(tab, 'tab-closed', tab)
          break
        }
      }
      this.ensureValidTabSelection()
    },
    
    closeDynamicTabs() {
      for (let i = this.tabs.length - 1; i >= 0; i--) {
        const tab = this.tabs[i]
        const hasRevisions = tab.document && tab.document.hasRevisions

        if (tab.dynamic && !tab.pinned && !hasRevisions) {
          this.tabs.splice(i, 1)
        }
      } 
      this.ensureValidTabSelection() 
    },

    togglePin(tab) {
      tab.pinned = !tab.pinned

      if (tab.pinned) {
        this.emitTabEvent(tab, 'tab-pinned', tab)
      }
      else {
        this.emitTabEvent(tab, 'tab-unpinned', tab)
      }
    },

    scrollTabHeaderIntoView(tab) {
      if (!this.$refs.tabHeaders) {
        return
      }
      
      for (let tabRef of this.$refs.tabHeaders) {
        if (tabRef.id === `header-${tab.id}`) {
          tabRef.scrollIntoView()
          return
        }
      }
    },

    ensureValidTabSelection() {
      if (!this.tabs.length) {
        this.showTabIndex = -1
      }
      else if (this.showTabIndex < 0) {
        this.showTabIndex = 0
      }
      else if (this.showTabIndex >= this.tabs.length) {
        this.showTabIndex = this.tabs.length - 1
      }
    },

    emitTabEvent(tab, event, ...data) {
      if (tab.events && tab.events[event]) {
        tab.events[event](...data)
      }
      this.$emit(event, ...data)
    },
  },
  watch: {
    
  }
}
